import { providerFundingMethod } from '../bank-transfers/types.js';
export function cardPaymentMethod(method, id) {
    if (method === 'card') {
        if (!id || id.length > 256 || !/^[!-~]+$/.test(id))
            throw new Error('onramp_card_binding_invalid');
        return { type: method, id };
    }
    if (id !== undefined)
        throw new Error('onramp_card_binding_invalid');
    return { type: providerFundingMethod(method) };
}
